import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";

export const StyledTextfield = styled(TextField)({
  "& .MuiInputBase-root.MuiInput-root:before": {
    content: `""`,
    border: "none",
  },
});
